import { render, staticRenderFns } from "./ResendInvite.vue?vue&type=template&id=46dc4a16&"
import script from "./ResendInvite.vue?vue&type=script&lang=js&"
export * from "./ResendInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports